module.exports = __webpack_public_path__ + "img/21_maska_kvadrat-shtrih.723f137.svg";